console.log('Welcome to my console. No errors to see here ;)');
